import { NskHead } from "~/components/common/head/NskHead";
import { VendorLayoutV2 } from "~/components/common/layouts/VendorLayoutV2";
import { Page as Component } from "~/components/specifics/vendors/deals/[id]/deal_estimation_headers/[headerId]/Page";

export const PATH = (id: number, headerId: number): string =>
	`/vendors/deals/${id}/deal_estimation_headers/${headerId}`;

function DealEstimationHeaders() {
	return (
		<>
			<NskHead title="見積り履歴確認" />
			<VendorLayoutV2>
				<Component />
			</VendorLayoutV2>
		</>
	);
}

export default DealEstimationHeaders;
